import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackZoneMappingDTo } from './rack-zone-mapping.dto';



export class RackZoneMappingResponseModel extends GlobalResponseObject{
    data?: RackZoneMappingDTo;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: RackZoneMappingDTo) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 